module.exports = __webpack_public_path__ + "static/Fellix-Bold-5faa98bb9fed539180f5d8cb8c1d7ab0.woff";